<section class="flex flex-col font-display">
  <span class="text-2xl sm:text-3xl font-bold">Verificator</span>
  <div class="flex flex-wrap items-center mt-6 gap-3">
    <button
      (click)="changeFilter('all')"
      [ngClass]="{ 'ring-2 ring-gray-500': currentFilter == 'all' }"
      class="px-4 sm:px-6 py-3 rounded-xl font-medium text-black border border-black flex items-center space-x-3 justify-center"
    >
      <div
        class="rounded-full h-8 w-8 flex items-center justify-center bg-black text-white"
      >
        {{ counter.all }}
      </div>
      <span>All</span>
    </button>
    <button
      (click)="changeFilter('received')"
      [ngClass]="{ 'ring-2 ring-gray-500': currentFilter == 'received' }"
      class="px-4 sm:px-6 py-3 rounded-xl font-medium text-white bg-[#FDCBAA] flex items-center space-x-3 justify-center"
    >
      <div
        class="rounded-full h-8 w-8 flex items-center justify-center bg-[#F68E17]"
      >
        {{ counter.unverified }}
      </div>
      <span>Unverified</span>
    </button>
    <button
      (click)="changeFilter('approved')"
      [ngClass]="{ 'ring-2 ring-gray-500': currentFilter == 'approved' }"
      class="px-4 sm:px-6 py-3 rounded-xl font-medium text-white bg-[#AACAFD] flex items-center space-x-3 justify-center"
    >
      <div
        class="rounded-full h-8 w-8 flex items-center justify-center bg-[#5582C9]"
      >
        {{ counter.verified }}
      </div>
      <span>Verified</span>
    </button>
    <button
      (click)="changeFilter('rejected')"
      [ngClass]="{ 'ring-2 ring-gray-500': currentFilter == 'rejected' }"
      class="px-4 sm:px-6 py-3 rounded-xl font-medium text-white bg-[#FFE1E0] flex items-center space-x-3 justify-center"
    >
      <div
        class="rounded-full h-8 w-8 flex items-center justify-center bg-[#FF6A65]"
      >
        {{ counter.rejected }}
      </div>
      <span>Rejected</span>
    </button>
  </div>
  <div class="mt-6">
    <mat-divider class="!border-gray-300"></mat-divider>
  </div>
  <div class="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between mt-6">
    <div class="relative w-full sm:w-1/2 lg:w-1/3">
      <input
        type="text"
        [formControl]="searchFormControl"
        class="w-full h-12 border border-gray-200 rounded-lg p-4 pl-11 text-[#5C5C5C] text-sm focus:outline-none"
        placeholder="Cari..."
      />
      <i class="fa-solid fa-magnifying-glass absolute left-4 top-4"></i>
    </div>
    <button
      [matMenuTriggerFor]="menuFilter"
      class="w-full sm:w-auto min-w-32 h-12 rounded-lg border border-gray-300 text-black flex items-center justify-center space-x-2"
    >
      <i class="fa-solid fa-filter"></i>
      <span>Filter</span>
    </button>

    <mat-menu #menuFilter="matMenu">
      <button mat-menu-item [matMenuTriggerFor]="date">
        <span class="font-display text-sm"
          ><i class="fa-solid fa-calendar mr-4"></i>Date</span
        >
      </button>
      <button mat-menu-item [matMenuTriggerFor]="expenseCategory">
        <span class="font-display text-sm"
          ><i class="fa-solid fa-folder mr-4"></i>Expense Category</span
        >
      </button>
      <button mat-menu-item [matMenuTriggerFor]="tag">
        <span class="font-display text-sm"
          ><i class="fa-solid fa-tag mr-4"></i>Tag</span
        >
      </button>
    </mat-menu>

    <mat-menu #date="matMenu">
      <div
        class="p-4 flex flex-col space-y-2 font-display"
        (click)="$event.stopPropagation()"
      >
        <span class="text-sm">Select Date</span>
        <input
          type="date"
          placeholder="Pilih tanggal"
          class="min-w-10 border border-gray-200 rounded-md px-3 py-2 text-sm focus:outline-none"
        />
      </div>
    </mat-menu>

    <mat-menu #expenseCategory="matMenu">
      <div
        class="p-4 flex flex-col space-y-2 font-display min-w-32"
        (click)="$event.stopPropagation()"
      >
        <div class="border-b border-gray-200 flex items-center space-x-4 pb-2">
          <i class="fa-solid fa-folder"></i>
          <input
            type="text"
            placeholder="Cari kategori..."
            class="text-sm focus:outline-none"
          />
        </div>
        <div class="grid grid-cols-2 gap-4">
          <div
            class="w-full py-1 text-sm bg-[#AACAFD] text-[#3F5C89] flex items-center justify-center rounded-md"
          >
            Acara
          </div>
        </div>
        <div></div>
        <div class="flex flex-col space-y-2">
          <div class="flex items-center justify-between">
            <span>Konsumsi</span>
            <button
              class="flex items-center justify-center border border-black rounded-full h-4 w-4"
            >
              <i class="fa-solid fa-plus text-xs"></i>
            </button>
          </div>
          <div class="flex items-center justify-between">
            <span>Acara</span>
            <button
              class="flex items-center justify-center border border-black rounded-full h-4 w-4"
            >
              <div class="bg-black rounded-full h-3 w-3"></div>
            </button>
          </div>
          <div class="flex items-center justify-between">
            <span>Perjalanan Dinas</span>
            <button
              class="flex items-center justify-center border border-black rounded-full h-4 w-4"
            >
              <i class="fa-solid fa-plus text-xs"></i>
            </button>
          </div>
          <div class="flex items-center justify-between">
            <span>Operasional Kantor</span>
            <button
              class="flex items-center justify-center border border-black rounded-full h-4 w-4"
            >
              <i class="fa-solid fa-plus text-xs"></i>
            </button>
          </div>
        </div>
      </div>
    </mat-menu>

    <mat-menu #tag="matMenu">
      <div
        class="p-4 flex flex-col space-y-2 font-display min-w-32"
        (click)="$event.stopPropagation()"
      >
        <div class="border-b border-gray-200 flex items-center space-x-4 pb-2">
          <i class="fa-solid fa-folder"></i>
          <input
            type="text"
            placeholder="Cari tag..."
            class="text-sm focus:outline-none"
          />
        </div>
        <div class="grid grid-cols-2 gap-4">
          <div
            class="w-full py-1 text-sm bg-[#FDF7AA] text-[#6E691F] flex items-center justify-center rounded-md"
          >
            Tag 1
          </div>
        </div>
        <div></div>
        <div class="flex flex-col space-y-2">
          <div class="flex items-center justify-between">
            <span>Januari Expense</span>
            <button
              class="flex items-center justify-center border border-black rounded-full h-4 w-4"
            >
              <i class="fa-solid fa-plus text-xs"></i>
            </button>
          </div>
          <div class="flex items-center justify-between">
            <span>Tag 1</span>
            <button
              class="flex items-center justify-center border border-black rounded-full h-4 w-4"
            >
              <div class="bg-black rounded-full h-3 w-3"></div>
            </button>
          </div>
          <div class="flex items-center justify-between">
            <span>Testing Tag</span>
            <button
              class="flex items-center justify-center border border-black rounded-full h-4 w-4"
            >
              <i class="fa-solid fa-plus text-xs"></i>
            </button>
          </div>
        </div>
      </div>
    </mat-menu>
  </div>
  <div class="overflow-x-auto">
  <table mat-table
      [dataSource]="dataSource"
      class="mat-elevation-z0 mt-6 font-display min-w-max w-full"
    >
      <ng-container matColumnDef="no">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="!font-semibold text-base sm:text-lg whitespace-nowrap"
        >
          No.
        </th>
        <td mat-cell *matCellDef="let element; let i = index">
          {{ parseNo(i) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="refId">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="!font-semibold text-base sm:text-lg whitespace-nowrap"
        >
          Ref ID
        </th>
        <td mat-cell *matCellDef="let element">
          <span
            *ngIf="element.cashadvance?.refId; else emptyRefId"
            class="inline-flex items-center rounded-md bg-slate-100 px-2 py-1 text-xs font-semibold text-slate-900"
            >#{{ element.cashadvance?.refId }}</span
          >
          <ng-template #emptyRefId>-</ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="file">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="!font-semibold text-base sm:text-lg whitespace-nowrap"
        >
          File
        </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="getFileItems(element).length; else noFile">
            <div class="flex flex-col gap-1">
              <button
                *ngFor="let fileItem of getFileItems(element)"
                type="button"
                class="inline-flex items-center gap-2 rounded-md border border-slate-200 bg-white px-2.5 py-1 text-xs font-semibold text-slate-700 hover:border-slate-300 hover:text-slate-900"
                (click)="download(fileItem)"
              >
                <i class="fa-solid fa-download text-xs"></i>
                <span class="max-w-[140px] truncate">{{
                  fileItem.fileName ?? 'Attachment'
                }}</span>
              </button>
            </div>
          </ng-container>
          <ng-template #noFile>-</ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="title">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="!font-semibold text-base sm:text-lg whitespace-nowrap"
        >
          Title
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.cashadvance?.title || '-' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="expanse_category">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="!font-semibold text-base sm:text-lg whitespace-nowrap"
        >
          Expense Category
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.cashadvance?.expenseCategory?.name ?? '-' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="!font-semibold text-base sm:text-lg whitespace-nowrap"
        >
          Status
        </th>
        <td mat-cell *matCellDef="let element">
          <span
            *ngIf="element.cashadvance?.status; else emptyStatus"
            class="px-2 py-1 rounded-md text-xs font-semibold uppercase tracking-wide"
            [ngClass]="{
              'bg-slate-100 text-slate-900':
                !element.cashadvance?.status ||
                element.cashadvance?.status == 'Draft' ||
                element.cashadvance?.status == 'Closed',
              'bg-orange-100 text-orange-900':
                element.cashadvance?.status == 'Sent' ||
                element.cashadvance?.status == 'Settlement Sent',
              'bg-blue-100 text-blue-900':
                element.cashadvance?.status == 'Approved' ||
                element.cashadvance?.status == 'Settlement Verified',
              'bg-red-100 text-red-900':
                element.cashadvance?.status == 'Rejected' ||
                element.cashadvance?.status == 'Settlement Rejected',
              'bg-rose-100 text-rose-900':
                element.cashadvance?.status == 'Rejected Finance',
              'bg-amber-100 text-amber-900':
                element.cashadvance?.status == 'Sent To Finance' ||
                element.cashadvance?.status == 'Settlement Sent To Finance',
              'bg-emerald-100 text-emerald-900':
                element.cashadvance?.status == 'Finance Approve' ||
                element.cashadvance?.status == 'Disbursed'
            }"
          >
            {{ element.cashadvance?.status }}
          </span>
          <ng-template #emptyStatus>-</ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="date">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="!font-semibold text-base sm:text-lg whitespace-nowrap"
        >
          Date
        </th>
        <td mat-cell *matCellDef="let element" class="whitespace-nowrap">
          {{
            element.cashadvance?.startDate
              ? (element.cashadvance?.startDate | date : 'fullDate' : '+0700')
              : '-'
          }}
          -
          {{
            element.cashadvance?.endDate
              ? (element.cashadvance?.endDate | date : 'fullDate' : '+0700')
              : '-'
          }}
        </td>
      </ng-container>

      <ng-container matColumnDef="amount">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="!font-semibold text-base sm:text-lg whitespace-nowrap"
        >
          Amount
        </th>
        <td mat-cell *matCellDef="let element" class="whitespace-nowrap">
          {{
            element.cashadvance?.amount != null
              ? (element.cashadvance?.currency || '') +
                ' ' +
                (element.cashadvance?.amount | number)
              : '-'
          }}
        </td>
      </ng-container>

      <ng-container stickyEnd matColumnDef="action">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="!font-semibold text-base sm:text-lg whitespace-nowrap"
        >
          Action
        </th>
        <td mat-cell *matCellDef="let element">
          <button
            type="button"
            [matMenuTriggerFor]="menu"
            class="inline-flex h-9 w-9 items-center justify-center rounded-full border border-slate-200 text-slate-600 hover:border-slate-300 hover:text-slate-900"
          >
            <i class="fa-solid fa-ellipsis-vertical"></i>
          </button>

          <mat-menu #menu="matMenu">
            <button
              mat-menu-item
              (click)="detailReimburse(element.cashadvance?.id)"
            >
              <span class="font-display text-sm">
                <i class="fa-solid fa-eye mr-3"></i>Detail
              </span>
            </button>
          </mat-menu>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="displayedColumns.length">
          <div
            class="w-full flex flex-col items-center justify-center gap-2 py-6 text-center font-display"
          >
            <div
              class="flex h-10 w-10 items-center justify-center rounded-full bg-slate-100 text-slate-400"
            >
              <i class="fa-solid fa-inbox"></i>
            </div>
            <span class="text-sm font-semibold text-slate-700"
              >No data available</span
            >
            <span class="text-xs text-slate-500"
              >Try adjusting filters or search.</span
            >
          </div>
        </td>
      </tr>
    </table>
</div>
  <mat-paginator
    [length]="dataTotal"
    [pageSize]="limit"
    [pageSizeOptions]="pageSizeOption"
    (page)="onPageChange($event)"
    aria-label="Select page"
  >
  </mat-paginator>
</section>
